// A compact silhouette of the periodic table -- two tall corner blocks, the short 2nd/3rd
// period, the long transition rows, and a detached f-block strip. Hand-drawn like RingIcon /
// BondGlyph; colour follows `currentColor`, the parent control carries the accessible name.
const RECTS: readonly [x: number, y: number, w: number, h: number][] = [
  [2, 4, 4, 4],
  [26, 4, 4, 4],
  [2, 9, 9, 4],
  [21, 9, 9, 4],
  [2, 14, 28, 4],
  [2, 19, 28, 4],
  [6, 25, 22, 3]
];

export function PeriodicTableIcon() {
  return (
    <svg className="periodic-table-icon" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      {RECTS.map(([x, y, w, h]) => (
        <rect key={`${x}-${y}`} x={x} y={y} width={w} height={h} rx="1" />
      ))}
    </svg>
  );
}
